<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img :src="icon" :alt="tenant.Name" width="120" height="120" />
                  <h1 class="flex my-4 primary--text">{{tenant.Name}}</h1>
                </div>
                <v-form v-model="valid" lazy-validation ref="form">
                  <v-text-field
                    append-icon="person"
                    label="帐号"
                    type="text"
                    v-model="model.account"
                    required
                    @keydown.enter="login"
                    placeholder="请输入您的帐号"
                    :rules="accountRules"
                  ></v-text-field>
                  <v-text-field
                    append-icon="lock"
                    label="密码"
                    type="password"
                    required
                    v-model="model.password"
                    placeholder="请输入您的密码"
                    @keydown.enter="login"
                    :rules="passwordRules"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn block color="primary" @click="login" :loading="loading">登陆</v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat small to="/regist">注册</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
// import { validationMixin } from 'vuelidate'
// import { required, maxLength, email } from 'vuelidate/lib/validators'
import png from "@/assets/logo.png";
import { alert } from "@/utils.js";
export default {
  data: () => ({
    loading: false,
    model: {
      account: "",
      password: ""
    },
    valid: true,
    accountRules: [
      v => !!v || "请填写帐号",
      v => (v && v.length >= 4 && v.length < 20) || "长度不正确"
    ],
    passwordRules: [
      v => !!v || "请填写密码",
      v => (v && v.length >= 4 && v.length < 20) || "长度不正确"
    ]
  }),
  created() {},
  computed: {
    tenant() {
      return this.$store.state.tenant;
    },
    icon() {
      return this.tenant.HandIcon_Id
        ? `/api/resource/get/${this.tenant.HandIcon_Id}`
        : png;
    }
  },
  methods: {
    async login() {
      if (!this.$refs.form.validate()) {
        alert.warning("请填写完整信息!");
        return;
      }
      this.loading = true;
      try {
        let request = await this.$http.post("/api/account/login", this.model);
        alert.success("登陆成功!");
        this.$store.commit("login", request);
        localStorage.setItem("token", request.ToKen);
        let redirect = this.$route.query.redirect || "/";
        this.$router.push(redirect);
      } finally {
        this.loading = false;
      }
    }
  }
};

function getUrl(cbName) {
  var cb = function() {};
  if (typeof cbName == "function") {
    cb = cbName;
  } else if (typeof cbName == "string" && window[cbName]) {
    cb = window[cbName];
  }
  var search = document.location.search;

  var reg = /v=(.+)&{0,1}/;
  if (reg.test(search)) {
    var id = reg.exec(search)[1];
    var value = localStorage.getItem(id);
    if (value) {
      cb(JSON.parse(value));
      return;
    }
    fetch("/get_video_info?video_id=" + id)
      .then(function(v) {
        return v.text();
      })
      .then(function(txt) {
        var arr = txt
          .split("&")
          .map(function(v) {
            return v.split("=");
          })
          .filter(function(v) {
            return v.length == 2;
          })
          .map(function(v) {
            return { key: v[0], value: unescape(v[1]) };
          })
          .filter(function(v) {
            return v.key == "url_encoded_fmt_stream_map";
          })
          .map(function(v) {
            return v.value;
          })
          .map(function(v) {
            return v.split(",");
          })
          .filter(function(v) {
            return !!v;
          });
        if (arr.length == 0) {
          cb(null);
          return;
        }

        var list = arr[0]
          .map(function(v) {
            return v
              .split("&")
              .map(function(r) {
                return r.split("=");
              })
              .map(function(r) {
                return { key: r[0], value: unescape(r[1]) };
              });
          })
          .map(function(v) {
            var obj = {};
            for (let index = 0; index < v.length; index++) {
              const item = v[index];
              obj[item.key] = item.value;
            }
            return obj;
          });
        localStorage.setItem(id, JSON.stringify(list));
        cb(list);
      });
  } else {
    cb(null);
  }
} 
 
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
